<template>
  <el-container :class="{ 'overflow--hidden': show }">
    <el-main>
      <div id="leaves">
        <i></i>
        <i></i>
        <i></i>
        <i></i>
        <i></i>
        <i></i>
        <i></i>
        <i></i>
        <i></i>
      </div>
      <el-row>
        <el-col
          :span="24"
          style="display: flex;justify-content: center;margin-bottom: 12px"
        >
          <transition
            appear
            appear-to-class="animate__animated animate__flipInX "
          >
            <img src="./../../assets/image/schoolicon.png" alt="" height="72" />
          </transition>
        </el-col>
        <el-col :span="24">
          <div class="name-wrap">
            <transition
              appear
              appear-to-class="animate__animated animate__bounceInDown animate__delay-500ms"
            >
              <h3>
                电商选品虚拟仿真实验
              </h3>
            </transition>
            <transition
              appear
              appear-to-class="animate__animated animate__fadeInDown animate__delay-2s "
            >
              <h6>
                Virtual simulation experiment of tea industry e-commerce
                selection for Southeast Asia
              </h6>
            </transition>
          </div>
        </el-col>
      </el-row>
      <div class="main-wrap">
        <div class="view">
          <transition
            appear
            appear-to-class="animate__animated animate__fadeInLeft animate__delay-1s "
          >
            <div class="information-detail">
              <div class="header">
                简介视频
              </div>
              <div class="content">
                <video
                  id="introduction"
                  :src="`${publicPath}introduction.mp4`"
                  controls
                  width="100%"
                ></video>
              </div>
              <div class="foot">
                <button style="margin-right: 62px" @click="show = true">
                  <div class="icon">
                    <img src="@/assets/image/video.png" alt="" />
                  </div>
                  <div class="txt">
                    教学引导视频
                  </div>
                  <div class="sub-txt">
                    Instructional video
                  </div>
                </button>
                <a
                  :href="`${publicPath}documents.docx`"
                  target="_blank"
                  download="电商选品虚拟仿真实验-操作流程文档.docx"
                >
                  <button>
                    <div class="icon">
                      <img src="@/assets/image/document.png" alt="" />
                    </div>
                    <div class="txt">
                      操作流程文档
                    </div>
                    <div class="sub-txt">
                      Operation flow document
                    </div>
                  </button>
                </a>
              </div>
            </div>
          </transition>
          <transition
            appear
            appear-to-class="animate__animated animate__fadeInRight animate__delay-1s "
          >
            <div class="information-txt">
              <div class="title">
                <h3>
                  项目简介
                </h3>
                <p>
                  project brief
                </p>
              </div>
              <div class="content">
                <div class="txt">
                  <p>
                    本项目是电商选品虚拟仿真实验。精心甄选福建优势产品——茶叶作为跨境选品的分析对象，以RCEP成员马来西亚、泰国和越南作为销售目标，以东南亚流行的Shopee平台数据作为分析模型进行虚拟仿真。学生通过细致的筛查，对Shopee平台数据中饮品类目里的卖家数量、总销量、评论数量进行交叉比对分析，再基于三个不同国家的消费者画像，从而梳理出福建特色茶叶产品大红袍、正山小种、茉莉花茶适宜的销售区域及目标群体。进而身临其境的学习跨境数据选品的操作及逻辑，掌握多维度选品的方法和技巧。
                  </p>
                  <p>
                    This project is a virtual simulation experiment for tea
                    industry e-commerce selection in Southeast Asia.tea was
                    carefully selected from FuJian as the analysis object of
                    cross-border selection, RCEP members Malaysia, Thailand and
                    Vietnam as the sales target， and virtual simulation with
                    popular Shopee platform data in Southeast Asia as the
                    analysis model. Through careful screening, students
                    cross-compared the number of sellers, tota sales volume and
                    comments of drinks in the Shopee platform data, and then
                    based on consumer portraits of three different countries, So
                    as to sort out the suitable sales areas and target groups of
                    red characteristic tea products, mountain and jasmine tea of
                    Fujian. Then immersive to learn the operation and logic of
                    cross-border data selection, to master the methods and
                    skills of multi-dimensional product selection.
                  </p>
                </div>
              </div>
              <div class="foot">
                <button @click="start">
                  <div class="txt">
                    开始 START
                  </div>
                </button>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </el-main>
    <transition
      name="custom-classes-transition"
      enter-active-class="animate__animated animate__backInDown"
      leave-active-class="animate__animated animate__backOutUp"
    >
      <div v-if="show" class="iframe-wrap">
        <div class="iframe-view">
          <video
            :src="`${publicPath}guidance.mp4`"
            controls
            width="100%"
            autoplay
          ></video>
          <div class="close" @click="show = false">
            <i class="el-icon-close"></i>
          </div>
        </div>
      </div>
    </transition>
  </el-container>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      publicPath: process.env.BASE_URL,
    };
  },
  watch: {
    show: (newv) => {
      switch (newv) {
        case true:
          document.querySelector("main.el-main").classList.add("blur");
          document.querySelector("#introduction").pause();
          break;
        case false:
          document.querySelector("main.el-main").classList.remove("blur");
          document.querySelector("#introduction").play();
          break;
      }
    },
  },
  methods: {
    start() {
      if (document.referrer === "http://211.80.209.22/") {
        window.top.location.href = `http://hq.gec-star.com/tologin${window.location.search}&ip=${document.referrer}`;
      } else {
        this.$router.push("/tologin");
      }
    },
  },
  mounted() {
    let video = document.querySelector("#introduction");
    video.addEventListener("ended", () => {
      video.load();
    });
  },
};
</script>

<style scoped lang="scss">
::v-deep .el-main {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  overflow: hidden;

  &.blur {
    filter: blur(10px);
  }
}

.name-wrap {
  text-align: center;
  margin-bottom: 42px;

  h3 {
    font-size: 36px;
    font-weight: bold;
    line-height: 46px;
    color: #005be7;
    opacity: 1;
    margin-bottom: 4px;
  }

  h6 {
    font-size: 16px;
    font-weight: 400;
    color: #005be7;
    opacity: 1;
  }
}

.main-wrap {
  width: 100%;
  display: flex;
  justify-content: center;
  overflow: hidden;
  padding-bottom: 10px;
}

.view {
  width: 100%;
  max-width: 1600px;
  display: flex;
}

.information-detail {
  width: 1000px;
  margin-right: 40px;
  height: 680px;
  background: #ffffff;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
  border-radius: 12px;
  padding: 20px 40px 40px 40px;

  .header {
    font-size: 20px;
    font-weight: bolder;
    margin-bottom: 8px;
  }

  .content {
    width: 100%;
    height: 510px;
    border-radius: 12px;
    overflow: hidden;
    background: #f1f1f1;
    margin-bottom: 30px;

    img {
      object-fit: cover;
    }
  }

  .foot {
    text-align: center;

    button {
      width: 226px;
      height: 60px;
      background: linear-gradient(
        90deg,
        rgba(119, 166, 239, 0.97) 0%,
        #005be7 100%
      );
      box-shadow: 0px 1px 4px rgba(119, 166, 239, 0.97);
      opacity: 1;
      border-radius: 60px;
      position: relative;
      padding-left: 72px;
      text-align: left;

      &:hover {
      }

      .icon {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 32px;
        margin: auto;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        float: left;
      }

      .txt {
        font-family: Microsoft YaHei UI, serif;
        font-size: 20px;
        font-weight: 400;
        line-height: 25px;
        color: #ffffff;
        margin-bottom: 4px;
      }

      .sub-txt {
        font-size: 10px;
        font-weight: 400;
        line-height: 13px;
        color: #ffffff;
        text-transform: capitalize;
      }
    }
  }
}

.information-txt {
  border-radius: 12px;
  padding: 36px;
  height: 680px;
  background: #ffffff;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.16);
  display: flex;
  flex-direction: column;
  flex: 1;

  .title {
    margin-bottom: 34px;

    h3 {
      font-size: 26px;
      font-weight: bold;
      line-height: 33px;
      color: #454b60;
    }

    p {
      font-size: 12px;
      font-weight: 400;
      color: #999999;
      text-transform: uppercase;
    }
  }

  .content {
    overflow: hidden;
    margin-bottom: 2px;

    .txt {
      height: 464px;
      font-size: 14px;
      line-height: 23px;
      color: #454b60;

      p {
        text-indent: 28px;
      }
    }
  }

  .foot {
    text-align: center;

    button {
      width: 226px;
      height: 60px;
      background: linear-gradient(
        90deg,
        rgba(119, 166, 239, 0.97) 0%,
        #005be7 100%
      );
      box-shadow: 0px 1px 4px rgba(119, 166, 239, 0.97);
      opacity: 1;
      border-radius: 60px;
      position: relative;
      text-align: center;

      .txt {
        font-family: Microsoft YaHei UI, serif;
        font-size: 20px;
        font-weight: 400;
        line-height: 25px;
        color: #ffffff;
        margin-bottom: 4px;
      }

      .sub-txt {
        font-size: 10px;
        font-weight: 400;
        line-height: 13px;
        color: #ffffff;
      }
    }
  }
}

.overflow--hidden {
  height: 100vh;
  overflow: hidden;
}

.iframe-wrap {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1111;
  width: 80%;
  margin: auto;
  border-radius: 20px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  .iframe-view {
    position: relative;

    .close {
      cursor: pointer;
      width: 40px;
      height: 40px;
      background: red;
      color: white;
      font-weight: bolder;
      position: absolute;
      right: 30px;
      top: 30px;
      border-radius: 50%;
      text-align: center;
      line-height: 40px;
      font-size: 20px;
    }
  }
}
</style>
